import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

export function DonateSuccess() {
  const { t } = useLang();
  const [params] = useSearchParams();
  const [state, setState] = useState("checking");
  const [amount, setAmount] = useState(null);

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState("error"); return; }
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setAmount(data.amount);
          setState("paid");
          return;
        }
      } catch (e) { /* keep polling */ }
      if (++tries < 8) setTimeout(poll, 2000);
      else setState("pending");
    };
    poll();
  }, [params]);

  return (
    <div className="min-h-screen grain flex items-center justify-center px-6 bg-[#050505]" data-testid="donate-success">
      <div className="glass rounded-2xl p-10 md:p-14 max-w-md w-full text-center purple-glow">
        {state === "checking" ? (
          <>
            <Loader2 className="mx-auto text-purple-400 animate-spin" size={48} />
            <p className="mt-6 text-white/70">{t.success.checking}</p>
          </>
        ) : (
          <>
            <CheckCircle2 className="mx-auto text-purple-400" size={56} />
            <h1 className="font-display uppercase text-4xl mt-6">{t.success.title}</h1>
            {amount ? <p className="text-purple-300 text-2xl font-display mt-2">${(amount / 100).toFixed(0)} CAD</p> : null}
            <p className="text-white/60 mt-4">{t.success.body}</p>
            <Link data-testid="success-home" to="/" className="inline-block mt-8 px-8 py-3.5 rounded-full bg-white text-black font-semibold hover:bg-purple-500 hover:text-white transition-colors">
              {t.success.back}
            </Link>
          </>
        )}
      </div>
    </div>
  );
}

export function DonateCancel() {
  const { t } = useLang();
  return (
    <div className="min-h-screen grain flex items-center justify-center px-6 bg-[#050505]" data-testid="donate-cancel">
      <div className="glass rounded-2xl p-10 md:p-14 max-w-md w-full text-center">
        <XCircle className="mx-auto text-white/50" size={56} />
        <h1 className="font-display uppercase text-4xl mt-6">{t.cancel.title}</h1>
        <p className="text-white/60 mt-4">{t.cancel.body}</p>
        <Link data-testid="cancel-home" to="/" className="inline-block mt-8 px-8 py-3.5 rounded-full border border-white/25 font-semibold hover:border-purple-500 hover:text-purple-300 transition-colors">
          {t.cancel.back}
        </Link>
      </div>
    </div>
  );
}
